<template>
  <!-- viewBox="0 0 16 16" -->
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M12.25 2C13.2165 2 14 2.7835 14 3.75L14 12.25C14 13.2165 13.2165 14 12.25 14L3.75 14C2.7835 14 2 13.2165 2 12.25L2 3.75C2 2.7835 2.7835 2 3.75 2L12.25 2ZM6.75 12.5L12.25 12.5C12.3881 12.5 12.5 12.3881 12.5 12.25L12.5 3.75C12.5 3.61193 12.3881 3.5 12.25 3.5L6.75 3.5L6.75 12.5ZM3.75 3.5C3.61193 3.5 3.5 3.61193 3.5 3.75L3.5 12.25C3.5 12.3881 3.61193 12.5 3.75 12.5H5.25L5.25 3.5L3.75 3.5Z"
    fill="currentColor"
  />
</template>
